module.exports = " <div class=\"card card-content\"> <div class=card-header> <breadcrumb :label=label></breadcrumb> <h1>Tableau de bord</h1> <div class=actions> <a class=\"btn btn-link\" href=\"\" v-link=\"{path: '/add'}\">Créer</a> <a class=\"btn btn-link\" href=#>Exporter</a> </div> </div> <div class=Calendar></div> <div class=card-footer> <div class=actions> <a class=\"btn btn-link\" href=\"\" v-link=\"{path: '/add'}\">Créer</a> <a class=\"btn btn-link\" href=#>Exporter</a> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/calendar/Calendar.vue
// module id = 481
// module chunks = 1